import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";

import EquipmentTypeForm from "components/equipmentTypes/EquipmentTypeForm";
import { createEquipmentType } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const EquipmentTypeCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const equipmentType = {
    name: "",
    description: "",
    companies: [me.companyID ?? ""],
  };

  async function onSubmit(valuesParam) {
    try {
      const { name, description, companies } = valuesParam;

      setLoading(true);

      await API.graphql({
        query: createEquipmentType.replaceAll("__typename", ""),
        variables: {
          input: {
            name,
            description,
            companies,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/equipment-types");
    } catch (err) {
      toast.error(strings.responses[err]);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <EquipmentTypeForm onSubmit={onSubmit} initialValues={equipmentType} />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Tipo de Equipo",
    successAdded: "Tipo de Equipo agregado con éxito",
    responses: {},
  },
});

export default EquipmentTypeCreateForm;
